import { useState } from "react";

import { useGetDevelopmentSelection2dQuery } from "@/hooks/microservicesApi";

import ContentSelection from "./Content-Selection";
import TowerSelection from "./Tower-Selection";

const Seleccion_v2 = ({ developmentData, setIsInit }) => {
    const [options, setOptions] = useState([]);
    const [_towersOptions, setOptionsTowers] = useState(null);
    const [viewSelected, setViewSelected] = useState(null);
    const [step, setStep] = useState(1);
    const { data: developmentData2D } = useGetDevelopmentSelection2dQuery(developmentData?.id);

    return (
        <>
            {step == 1 ? (
                <TowerSelection
                    developmentData={developmentData}
                    setViewSelected={setViewSelected}
                    setStep={setStep}
                />
            ) : (
                <ContentSelection
                    developmentData={developmentData}
                    data={developmentData2D}
                    options={options}
                    setOptions={setOptions}
                    viewSelected={viewSelected}
                    setViewSelected={setViewSelected}
                    setOptionsTowers={setOptionsTowers}
                    setStep={setStep}
                    step={step}
                />
            )}
        </>
    );
};

export default Seleccion_v2;
